<ng-container *ngIf="warningContent">
  <nv-note size="small" priority="warning"><span #warningContent></span></nv-note>
</ng-container>
